import { useEffect, useState } from "react";
import { getCookie } from "../utils/getCookie";

const useAuthStatus = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const seaChangeAuthInfo = getCookie("userLoggedIn");

    if (seaChangeAuthInfo && seaChangeAuthInfo === "true") {
      setIsAuthenticated(true);
      return;
    }

    setIsAuthenticated(false);
    return;
  }, []);

  return isAuthenticated;
};

export default useAuthStatus;



// WEBPACK FOOTER //
// ./src/js/hooks/useAuthStatus.js